export default __webpack_public_path__ + "fonts/媒介支持.ce7d6fee26b99930bf678872a4d5c9df.png";